import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Input, Row, Select, Spin } from 'antd';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import {
  getEecsGoRowsForAction,
  getGroupedCertificates,
  getGroupedCertificatesData,
} from '../../reducers/accountOverviewReducer';
import * as selectors from '../../reducers/transferringCertificateReducer';
import * as actions from '../../actions/actionCreators/certificateActionCreators';
import { PerformCertificatesTable } from '../../components';
import { getCountriesAndRegistries } from '../../reducers/transferringCertificateReducer';
import i18n from '../../i18n';
import debounce from 'lodash/debounce';

class ReceiverInput extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  };

  state = { loading: false };

  debouncedChange = debounce((value) => {
    this.setState({ loading: false });
    this.props.onChange(value);
  }, 300);

  componentWillUnmount() {
    this.debouncedChange.cancel();
  }

  handleChange = (e) => {
    this.setState({ loading: true });
    this.debouncedChange(e.target.value);
  };

  render() {
    const { placeholder } = this.props;
    return (
      <Input
        style={{ width: '100%' }}
        onChange={this.handleChange}
        allowClear
        placeholder={placeholder}
        suffix={this.state.loading ? <Spin size="small" /> : <span />}
      />
    );
  }
}

export class ExportingCertificates extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    groupedCertificates: PropTypesImmutable.list.isRequired,
    t: PropTypes.func.isRequired,
    accountId: PropTypes.string.isRequired,
    selectedCountryOrRegistry: PropTypes.object,
    selectCountryOrRegistry: PropTypes.func.isRequired,
    exportCertificates: PropTypes.func.isRequired,
    countriesAndRegistriesFetch: PropTypes.func,
    countriesAndRegistries: PropTypes.array,
    eecsGoRows: PropTypes.array,
  };

  state = {
    exportReceiver: '',
  };

  componentDidMount() {
    this.props.selectCountryOrRegistry(null);
    this.setState({ exportReceiver: '' });
    this.props.countriesAndRegistriesFetch();
  }

  setReceiver = (value) => {
    this.setState({ exportReceiver: value });
  };

  validateExportCertificates = () => false;

  render() {
    const {
      isLoading,
      t,
      groupedCertificates,
      selectedCountryOrRegistry,
      selectCountryOrRegistry,
      exportCertificates,
      accountId,
      countriesAndRegistries,
      eecsGoRows,
    } = this.props;
    if (!isLoading && groupedCertificates.isEmpty()) {
      return t('groupedEmpty');
    }
    const accounts = accountId.split(',').map(Number);
    const canProceed = Boolean(
      this.state.exportReceiver && selectedCountryOrRegistry
    );
    const lang = i18n.resolvedLanguage || i18n.language;
    const filtered = groupedCertificates.filter((row) => {
      const value = row.get('fuelType');
      return value != null;
    });

    const groupedCertificatesFiltered = filtered.toJS();
    return (
      <Spin spinning={isLoading}>
        <Row gutter={[160, 0]} className="w-100">
          <Col flex="1">
            <h2>{t('exportCountry')}</h2>
            <Select
              value={selectedCountryOrRegistry?.id}
              onChange={(id) =>
                selectCountryOrRegistry(
                  countriesAndRegistries.find((item) => item.id === id)
                )
              }
              style={{ width: '100%' }}
              placeholder={t('chooseCountryOrRegister')}
              options={countriesAndRegistries?.map((item) => {
                const name = lang === 'et' ? item.etName : item.enName;
                const registrySuffix =
                  item.type === 'REGISTRY' ? ` (${item.code})` : '';
                const label = `${name}${registrySuffix}`;

                return {
                  label,
                  value: item.id,
                };
              })}
            />
          </Col>
          <Col flex="1">
            <h2>{t('receiver')}</h2>
            <ReceiverInput
              onChange={this.setReceiver}
              placeholder={t('enterReceiver')}
            />
          </Col>
        </Row>
        {canProceed && (
          <>
            <h2 className="global-margin-top-24">{t('defineGO')}</h2>
            <PerformCertificatesTable
              dataList={groupedCertificatesFiltered}
              eecsGoRows={eecsGoRows}
              isUsersOtherAccount={false}
              validateAction={this.validateExportCertificates}
              performAction={(dataList, eecsGoRows) =>
                exportCertificates({
                  destination: selectedCountryOrRegistry,
                  receiver: this.state.exportReceiver,
                  currentAccountIds: accounts,
                  dataList,
                  eecsGoRows,
                })
              }
              isExporting
            />
          </>
        )}
      </Spin>
    );
  }
}

const getLoading = getLoadingSelector(
  getGroupedCertificates,
  selectors.getExporting
);

const mapStateToProps = (state) => ({
  isLoading: getLoading(state),
  groupedCertificates: getGroupedCertificatesData(state),
  selectedCountryOrRegistry: selectors.getSelectedCountryOrRegistry(state),
  countriesAndRegistries: getCountriesAndRegistries(state),
  eecsGoRows: getEecsGoRowsForAction(state),
});
const mapDispatchToProps = {
  selectCountryOrRegistry: actions.selectCountryOrRegistry,
  exportCertificates: actions.exportCertificates,
  countriesAndRegistriesFetch: actions.getCountriesAndRegistries,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportingCertificates);
